import { render } from "./index.vue?vue&type=template&id=c23691d8&bindings={}"
import script from "./ClickSection.js?vue&type=script&lang=js"
export * from "./ClickSection.js?vue&type=script&lang=js"

import "./ClickSection.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script